import React from 'react';
import translate from '../../lib/i18n/translate'
import { Row, Col } from 'react-flexbox-grid';
import {DatePicker, IconButton,TextField} from 'material-ui'
import moment from 'moment';
import ActionDateRange from 'material-ui/svg-icons/action/date-range';

class TransactionDayPicker extends React.Component {

    constructor(props){
        super(props);

        this.state = {
            date: new Date(),
            dateText: moment().format('YYYY-MM-DD' )
        }

        this.handleDate = this.handleDate.bind(this);
        this.handleDateInputChange = this.handleDateInputChange.bind(this);
    };

    handleDate(event,date) {
        let momentDate =  encodeURIComponent(moment(date).format("YYYY-MM-DD"));
        this.pickTheDate(momentDate);
    }

    pickTheDate(momentDate) {
        this.props.openTransactionDayPick(momentDate)
    }

    handleDateInputChange(event, value) {
        this.setState({dateText:value});
    };

    onKeyPress(event) {
        if (event.charCode === 13) { // enter key pressed
            event.preventDefault();
            if (moment(this.state.dateText).isValid() ) {
                this.pickTheDate(this.state.dateText);
            }
        }
    }

    render() {
        let dateInputWidth = "120px";

        return (
            <Row middle="xs">
                <Col xs={12} sm={12} md={12} lg={12} style={{textAlign: 'right'}}>
                    <div style={{textAlign: 'right'}}>
                        <TextField
                            id="dateTextField"
                            style={{width:dateInputWidth}}
                            value={this.state.dateText}
                            onKeyPress={(event)=>{this.onKeyPress(event)}}
                            onChange={this.handleDateInputChange}
                        />
                        <IconButton style={{opacity:"0.65"}}
                                    onClick={() => this.datePicker.focus()}>
                            <ActionDateRange />
                        </IconButton>
                        <div style={{width:"0px", height:"0px", overflow: "hidden"}}>
                            <DatePicker
                                id="datePicker"
                                onChange={this.handleDate}
                                autoOk={true}
                                ref={c => {
                                    this.datePicker = c
                                }}/>
                        </div>
                    </div>
                </Col>
            </Row>
        )
    }
}

export default translate('TransactionDayPicker')(TransactionDayPicker);




// WEBPACK FOOTER //
// ./src/components/transactionDayList/TransactionDayPicker.js